import { usePrevious } from './usePrevious';
import { useEffect, useState } from 'react';

export function useAsyncDefaultState<T>(
	defaultValue?: T,
	onInitiatlize?: (value: T) => void
): [ T | undefined, (value: T | undefined) => void ] {
	const [ value, setValue ] = useState<T | undefined>(defaultValue);
	const [ initialized, setInitialized ] = useState(false);
	const previousDefaultValue = usePrevious(defaultValue);

	useEffect(() => {
		if (!initialized && !previousDefaultValue && defaultValue) {
			setInitialized(true);
			setValue(defaultValue);

			if (onInitiatlize) {
				onInitiatlize(defaultValue);
			}
		}
	}, [ defaultValue, initialized, onInitiatlize, previousDefaultValue ]);

	return [ value, setValue ];
}
